module.exports = __webpack_public_path__ + "img/heartFav.cd94ef3e.svg";